import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, ExternalLink } from 'lucide-react';
import { FiretreeLogo } from './FiretreeLogo';
import { openContactModal } from './ContactModal';
export function Footer() {
  return <footer className="bg-brand-charcoal text-brand-cream border-t border-brand-shape/20 pt-20 pb-12" data-id="element-79">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-80">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-81">
          <div className="col-span-1 md:col-span-2" data-id="element-82">
            <div className="brightness-0 invert mb-6 inline-block" data-id="element-83">
              <FiretreeLogo data-id="element-84" />
            </div>
            <p className="text-brand-shape max-w-md text-sm leading-relaxed" data-id="element-85">
              Firetree offers funders curated access to established, highly
              effective local organizations with proven models in Southeast
              Asia.
            </p>
          </div>

          <div data-id="element-86">
            <h3 className="font-serif text-lg mb-4 text-brand-gold" data-id="element-87">Explore</h3>
            <ul className="space-y-2 text-sm text-brand-shape" data-id="element-88">
              <li data-id="element-89">
                <Link to="/how-we-work" className="hover:text-white transition-colors" data-id="element-90">
                  How We Work
                </Link>
              </li>
              <li data-id="element-91">
                <Link to="/our-process" className="hover:text-white transition-colors" data-id="element-92">
                  How We Partner
                </Link>
              </li>
              <li data-id="element-93">
                <Link to="/who-we-fund" className="hover:text-white transition-colors" data-id="element-94">
                  Our Partners
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-95">
            <h3 className="font-serif text-lg mb-4 text-brand-gold" data-id="element-96">Connect</h3>
            <ul className="space-y-2 text-sm text-brand-shape" data-id="element-97">
              <li data-id="element-98">
                <Link to="/engage" className="hover:text-white transition-colors" data-id="element-99">
                  Engage With Us
                </Link>
              </li>
              <li data-id="element-100">
                <a href="https://firetree.org" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-101">
                  Firetree Group ↗
                </a>
              </li>
              <li data-id="element-102">
                <a href="https://firetree.org/team" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-103">
                  Meet the Team ↗
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-brand-brown/40 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-brand-brown" data-id="element-104">
          <p data-id="element-105">
            &copy; {new Date().getFullYear()} Firetree. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}